const DATA_SITE = 'AU';

const getPageName = () => {
  const pathname = window.location.href;
  if (pathname.includes('/product/')) return 'Package Selection';
  if (pathname.includes('/product_config/')) return 'Customisation';
  if (pathname.includes('/register')) return 'Sign Up';
  if (pathname.includes('/email')) return 'Email Validation';
  if (pathname.includes('/order') || pathname.includes('/payment')) return 'Order Status';
  if (pathname.includes('/pxpay')) return 'DPS';
  if (pathname.includes('/process_pxpay')) return 'DPS';
  if (pathname.includes('/payment_pxpay_status')) return 'DPS';
  if (pathname.includes('/checkout')) return 'Checkout';
  if (pathname.includes('/help-me-choose')) return 'HMCW';
  return 'Cart';
};

const analyticsAlias = (claudId) => {
  window.analytics.alias(claudId, {
    previousId: window.mixpanel.get_distinct_id(),
    userId: claudId
  });
};

const analyticsPageView = (page) => {
  window.analytics.page(page, {
    site: DATA_SITE
  });
};

const analyticsTrack = (trackingObj) => {
  trackingObj.data.site = DATA_SITE;
  window.analytics.track(trackingObj.eventType, trackingObj.data);
};

const trackApplyOrRemoveCoupon = (eventMessage, coupon) => {
  const pageName = getPageName();
  if (coupon) {
    let discount = null;
    if (coupon.discountServiceConfig) {
      const discountConfig = coupon.discountServiceConfig;
      if (discountConfig?.discountPercent > 0) {
        discount = `${discountConfig.discountPercent}%`;
      } else if (discountConfig?.discountFixed > 0) {
        discount = `$${discountConfig.discountFixed}`;
      } else if (discountConfig?.monthsDiscount > 0) {
        discount = `${discountConfig.monthsDiscount} months`;
      }
    }

    const trackingObj = {
      eventType: eventMessage,
      data: {
        Page: pageName,
        Coupon: coupon.code,
        Discount: discount,
        Referrer: coupon.agentName,
        name: pageName
      }
    };
    analyticsTrack(trackingObj);
  }
};

const trackCompanyInfo = (info) => {
  const pageName = getPageName();
  const trackingObj = {
    eventType: 'Go to company information page',
    data: {
      Page: pageName,
      Information: info,
      name: pageName
    }
  };
  analyticsTrack(trackingObj);
};

//Delete package
const trackDeletePackage = (quote) => {
  const pageName = getPageName();
  const trackingObj = {
    eventType: 'Delete Package',
    data: {
      Page: pageName,
      Product: quote.headLine,
      Industry: quote.productGroup,
      Package: quote.headLine,
      name: pageName
    }
  };
  analyticsTrack(trackingObj);
};

const trackError = (action, page, errorMessage, errorCode) => {
  const pageName = page ? page : getPageName();
  const trackingObj = {
    eventType: 'Capture Error',
    data: {
      site: DATA_SITE,
      Page: pageName,
      Action: action,
      'Error Message': errorMessage,
      'Error Code': errorCode,
      name: pageName
    }
  };
  analyticsTrack(trackingObj);
};

const trackGenericPageInfo = (eventMessage) => {
  const pageName = getPageName();
  const trackingObj = {
    eventType: eventMessage,
    data: {
      Page: pageName,
      name: pageName
    }
  };
  analyticsTrack(trackingObj);
};

//Track package Selection
const trackPackageSelection = (product, industry, packageName) => {
  const pageName = getPageName();
  const trackingObj = {
    eventType: 'Select Package',
    data: {
      Page: pageName,
      'Product Selected': product,
      Industry: industry,
      'Package Selected': packageName,
      name: pageName
    }
  };
  analyticsTrack(trackingObj);
};

//track paid order
const trackPaidOrder = (order, hmcw) => {
  const pageName = getPageName();
  let onceOffPrice = 0;
  let onceOffDiscount = 0;
  let subscriptionsPrice = 0;
  let subscriptionsDiscount = 0;

  const quotes = order.quotes.quotes;
  let orderType = quotes.length > 1 ? 'Combination' : null;

  for (let quoteIndex = 0; quoteIndex < quotes.length; quoteIndex++) {
    if (quotes[quoteIndex].minimumInitialTerm === 1) {
      onceOffPrice += quotes[quoteIndex].originalPrice;
      onceOffDiscount += quotes[quoteIndex].discount;
      if (orderType === null) {
        orderType = 'Once off';
      }
    } else {
      subscriptionsPrice += quotes[quoteIndex].originalPrice;
      subscriptionsDiscount += quotes[quoteIndex].discount;
      if (orderType === null) orderType = 'Subscription';
    }
  }

  const trackingObj = {
    eventType: 'Submit Order',
    data: {
      Page: pageName,
      'Order Type': orderType,
      'Order Number': order.orderNumber,
      'One off total': parseFloat((onceOffPrice / 1.1).toFixed(2)),
      'One off discount': parseFloat((onceOffDiscount / 1.1).toFixed(2)),
      'Subscription monthly amount': parseFloat((subscriptionsPrice / 1.1).toFixed(2)),
      'Subscription monthly discount': parseFloat((subscriptionsDiscount / 1.1).toFixed(2)),
      ACV: parseFloat((order.quotes.cartMinTotal / 1.1).toFixed(2)),
      'Cart discount': parseFloat((order.quotes.cartDiscount / 1.1).toFixed(2)),
      'Used HMCW': hmcw ? hmcw : 'No',
      name: pageName
    }
  };
  analyticsTrack(trackingObj);
};

const trackSignUp = (cta) => {
  const pageName = getPageName();
  const trackingObj = {
    eventType: 'Sign-in',
    data: {
      Page: pageName,
      CTA: cta,
      name: pageName
    }
  };
  analyticsTrack(trackingObj);
};

//track trial order
const trackTrialOrder = (order) => {
  const pageName = getPageName();
  const trackingObj = {
    eventType: 'Submit Order',
    data: {
      Page: getPageName(),
      'Order Type': 'Trial Request',
      'Order Number': order.orderNumber,
      name: pageName
    }
  };
  analyticsTrack(trackingObj);
};

const trackAction = (eventMessage, action, pageName) => {
  let trackingObj = {
    eventType: eventMessage,
    data: {
      Page: pageName ? pageName : getPageName(),
      Action: action
    }
  };
  analyticsTrack(trackingObj);
};

// HELP ME CHOOSE WIZARD

const trackHmcw = (pageName, industry) => {
  let trackingObj = {
    eventType: 'Start Help Me Choose Wizard',
    data: {
      Page: pageName ? pageName : getPageName(),
      Industry: industry
    }
  };
  analyticsTrack(trackingObj);
};

//User selects a industry
const trackIndustrySelection = (oldIndustry, newIndustry) => {
  let trackingObj = {
    eventType: 'User selects RPP Industry',
    data: {
      Page: getPageName(),
      'Previous Industry': oldIndustry,
      'Selected Industry': newIndustry
    }
  };
  analyticsTrack(trackingObj);
};

export default class SegmentAnalytics {
  // Add to Cart
  trackAddToCart = (cta, quote) => {
    const trackingObj = {
      eventType: 'Add to Cart',
      data: {
        Page: getPageName(),
        CTA: cta,
        Product: quote.productGroup,
        Package: quote.headLine,
        'Monthly Amount': quote.totalPerMonth
      }
    };
    analyticsTrack(trackingObj);
  };

  trackReturnToCorelogic = (product) => {
    let pageName = getPageName();
    let productName = null;

    if (pageName === 'Package Selection') {
      let path = window.location.pathname.split('/');
      //path[2] will return the friendly name for the product
      productName =
        product?.productsConfig && product.productsConfig[path[2]]
          ? product.productsConfig[path[2]].productName
          : null;
    }
    let trackingObj = {
      eventType: 'Return to corporate site',
      data: {
        Page: pageName,
        Product: productName
      }
    };
    analyticsTrack(trackingObj);
  };

  trackGotoCart = (itemsCount) => {
    let trackingObj = {
      eventType: 'Go to Cart',
      data: {
        Page: getPageName(),
        Number: itemsCount
      }
    };
    analyticsTrack(trackingObj);
  };

  //Track if email was validated
  trackEmailValidation = (validated) => {
    let trackingObj = {
      eventType: 'Email validation',
      data: {
        Page: getPageName(),
        Validated: validated ? 'Yes' : 'No'
      }
    };
    analyticsTrack(trackingObj);
  };

  //Continue shopping from email validation
  trackContinueShoppingFromEmailValidation = () => {
    let trackingObj = {
      eventType: 'Continue Shopping',
      data: {
        Page: getPageName(),
        'Entry Point': 'Expired / New Session'
      }
    };
    analyticsTrack(trackingObj);
  };

  //payment method
  trackPaymentMethod = (paymentMethod) => {
    let trackingObj = {
      eventType: 'Payment Method',
      data: {
        Page: getPageName(),
        'Payment Method Selected': paymentMethod === 'credit' ? 'Credit Card' : 'Direct Debit'
      }
    };
    analyticsTrack(trackingObj);
  };

  //Track order
  trackOrder = (order, type, hmcw) => {
    type === 'trial' ? trackTrialOrder(order) : trackPaidOrder(order, hmcw);
  };

  //Track Order Status
  trackOrderStatus = (order, result, reason, payment_id, hmcw) => {
    let onceOffPrice = 0;
    let subscriptionsPrice = 0;
    let orderType = '';

    let quotes = order.quotes.quotes;

    const productList = quotes.map((item) => item.headLine);
    const productGroupList = quotes.map((item) => item.productGroup);

    if (order.total === 0) {
      orderType = 'Trial Request';
    } else {
      orderType = quotes.length > 1 ? 'Combination' : null;

      for (let quoteIndex = 0; quoteIndex < quotes.length; quoteIndex++) {
        if (quotes[quoteIndex].minimumInitialTerm === 1) {
          onceOffPrice += quotes[quoteIndex].originalPrice;
          if (orderType === null) {
            orderType = 'Once off';
          }
        } else {
          subscriptionsPrice += quotes[quoteIndex].originalPrice;
          if (orderType === null) {
            orderType = 'Subscription';
          }
        }
      }
    }

    let trackingObj = {
      eventType: 'Order Status',
      data: {
        Page: getPageName(),
        Result: result,
        'Order Type': orderType,
        'Order Number': order.orderNumber,
        'One off total': parseFloat((onceOffPrice / 1.1).toFixed(2)),
        'Subscription monthly amount': parseFloat((subscriptionsPrice / 1.1).toFixed(2)),
        ACV: parseFloat((order.quotes.cartMinTotal / 1.1).toFixed(2)),
        Reason: reason,
        'Customer Id': order.customer.id,
        'Payment Id': payment_id,
        'Used HMCW': hmcw ? hmcw : 'No',
        'Product': productList.join(', '),
        'Group': productGroupList.join(', ')
      }
    };

    analyticsTrack(trackingObj);
  };

  trackWindcavePaymentStatus = (result, reason, payment) => {
    if (payment) {
      let trackingObj = {
        eventType: 'Sales assisted tokenisation',
        data: {
          Page: getPageName(),
          Result: result,
          'Opportunity Number': payment.opportunityNumber,
          Amount: payment.amount,
          Currency: payment.currency,
          Region: payment.region,
          Reason: reason
        }
      };
      analyticsTrack(trackingObj);
    }
  };

  // Step Action
  trackStep = (cta, currentStep) => {
    let trackingObj = {
      eventType: cta,
      data: {
        Page: `HMCW ${currentStep != 4 ? `Step ${currentStep}` : 'Recommendation'}`,
        Product: 'RP Data',
        Industry: 'Real Estate',
        CTA: cta
      }
    };
    analyticsTrack(trackingObj);
  };

  trackStepResponse = (currentStep, inputValues) => {
    let geographyList = inputValues.geography.value.map((item) => item.value);
    let problemsList = inputValues.problems.value.map((item) => item.value);

    let trackingObj = {
      eventType: 'HMC Wizard Response',
      data: {
        Page: `HMCW ${currentStep != 4 ? `Step ${currentStep}` : 'Recommendation'}`,
        'No. emp req RP Data': inputValues.employeeCount.value,
        'State/Territories': geographyList.join(', '),
        'HMCW Industry': inputValues.industry.value ? inputValues.industry.value : 'Not answered',
        'Typical sales': inputValues.salesRange.value
          ? inputValues.salesRange.value
          : 'Not answered',
        'No. properties managed': inputValues.propertiesRange.value
          ? inputValues.propertiesRange.value
          : 'Not answered',
        'Problems to solve': problemsList.length > 0 ? problemsList.join(', ') : 'Not answered',
        'RP Data Direct Marketing': inputValues.directMarketing.value,
        'RP Data custom reports': inputValues.dataReports.value,
        'Local market notifications': inputValues.notify.value,
        'Export property data': inputValues.dataExports.value,
        'Digital Proposals & Reports': inputValues.digitalProposals.value
      }
    };
    analyticsTrack(trackingObj);
  };

  // Add to Cart / Checkout
  trackHmcwAddToCart = (cta, inputValues) => {
    let geographyList = inputValues.geography.value.map((item) => item.value);
    let problemsList = inputValues.problems.value.map((item) => item.value);

    let trackingObj = {
      eventType: cta,
      data: {
        Page: 'HMCW Recommendation',
        Product: 'RP Data',
        Industry: 'Real Estate',
        CTA: cta,
        'No. emp req RP Data': inputValues.employeeCount.value,
        'State/Territories': geographyList.join(', '),
        'HMCW Industry': inputValues.industry.value,
        'Typical sales': inputValues.salesRange.value
          ? inputValues.salesRange.value
          : 'Not answered',
        'No. properties managed': inputValues.propertiesRange.value
          ? inputValues.propertiesRange.value
          : 'Not answered',
        'Problems to solve': problemsList.join(', '),
        'RP Data Direct Marketing': inputValues.directMarketing.value,
        'RP Data custom reports': inputValues.dataReports.value,
        'Local market notifications': inputValues.notify.value,
        'Export property data': inputValues.dataExports.value
      }
    };
    analyticsTrack(trackingObj);
  };

  

  // Track Edit HMCW
  trackHmcwEdit = (eventMessage, cta, name, inputValue) => {
    let selection = inputValue;
    if (inputValue && Array.isArray(inputValue) && inputValue.length > 0) {
      selection = inputValue.map((item) => item.value).join(', ');
    }

    let trackingObj = {
      eventType: eventMessage,
      data: {
        Page: 'HMCW Recommendation',
        Product: 'RP Data',
        Industry: 'Real Estate',
        'Selection to Edit': name,
        'Selection picked': selection,
        CTA: cta
      }
    };
    analyticsTrack(trackingObj);
  };

  analyticsHmcw = (page, product, industry) => {
    window.analytics.page(page, {
      site: DATA_SITE,
      Product: product,
      Industry: industry
    });
  };

  analyticsCheckout = (page, orderNumber) => {
    window.analytics.page(page, {
      site: DATA_SITE,
      'Order Number': orderNumber
    });
  };

  

  analyticsIdentity = (user) => {
    if (user) {
      window.analytics.identify(user.guid, {
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        username: user.username,
        site: DATA_SITE
      });
    }
  };

  analyticsIdentifyIndustry = (userId, industry) => {
    window.analytics.identify(userId, {
      industry: industry
    });
  };

  analyticsLogoutUser = () => {
    window.analytics.reset();
    window.mixpanel.reset();
  };
}

export {
  analyticsAlias,
  analyticsPageView,
  trackAction,
  trackApplyOrRemoveCoupon,
  trackCompanyInfo,
  trackDeletePackage,
  trackError,
  trackGenericPageInfo,
  trackHmcw,
  trackIndustrySelection,
  trackPackageSelection,
  trackSignUp
};
